import { render, staticRenderFns } from "./RichVerticalIndicator.vue?vue&type=template&id=0dfc0aba&scoped=true"
import script from "./RichVerticalIndicator.vue?vue&type=script&lang=js"
export * from "./RichVerticalIndicator.vue?vue&type=script&lang=js"
import style0 from "./RichVerticalIndicator.vue?vue&type=style&index=0&id=0dfc0aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfc0aba",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-wizard/indicators/RichVerticalIndicator.vue
// module id = PKk7
// module chunks = 41